// extracted by mini-css-extract-plugin
export var attachment = "_sb-a";
export var emailContainer = "_sb-4";
export var emailContentPaddedContainer = "_sb-b";
export var emailHeader = "_sb-6";
export var emailIframe = "_sb-3";
export var emailInfoIcon = "_sb-9";
export var emailShortenedSummary = "_sb-e";
export var infoDropdown = "_sb-0";
export var infoRowBoundedContent = "_sb-d";
export var internal = "_sb-5";
export var merchant = "_sb-8";
export var messageInputContainer = "_sb-h";
export var normal = "_sb-7";
export var replyCard = "_sb-f";
export var subtleButton = "_sb-1";
export var subtleButtonIconContainer = "_sb-2";
export var toggleViewRepliesButton = "_sb-c";
export var wrappingText = "_sb-g";